module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box fontFamily"
  }, [(false) ? _c('div', {
    staticClass: "index-header"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "242px",
      "width": "100%"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../assets/images/bg-background.png"),
      "alt": "",
      "srcset": ""
    }
  })]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "index-main"
  }, [_c('div', {
    staticClass: "main-box"
  }, [_c('slidePics', {
    attrs: {
      "content": [],
      "top": "0"
    }
  }), _vm._v(" "), _c('navButton')], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "more-box"
  }, [_vm._m(3), _vm._v(" "), (false) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "hot-sing-up"
  }, [_vm._v("火热报名中")]), _vm._v(" "), _vm._l((_vm.pageList.sai.doing), function(item, index) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'ISaiApplyFormStep1',
          'query': {
            'saiqu_id': item.id
          }
        }),
        expression: "{name:'ISaiApplyFormStep1','query':{ 'saiqu_id':item.id }}"
      }],
      key: index,
      staticStyle: {
        "margin-bottom": "20px",
        "border-bottom": "1px solid #00000010",
        "padding-bottom": "10px"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%",
        "position": "relative",
        "border-radius": "10px",
        "overflow": "hidden"
      }
    }, [_c('div', {
      staticClass: "active-couduct-box active-couduct1"
    }, [_vm._v("正在进行")]), _vm._v(" "), _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.pic_url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "active-couduct-title"
    }, [_c('img', {
      staticStyle: {
        "width": "20px",
        "height": "20px",
        "margin-right": "5px"
      },
      attrs: {
        "src": require("../../assets/images/icon-hot.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "active-title"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "couduct-address-box"
    }, [_c('div', {
      staticClass: "couduct-address"
    }, [_c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.saidate_str))]), _vm._v(" "), _c('div', {
      staticClass: "address"
    }, [_vm._v(_vm._s(item.province) + " " + _vm._s(item.city) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "sing-up-btn"
    }, [_vm._v("立即报名")])])])
  })], 2), _vm._v(" "), (false) ? _c('div', {
    staticClass: "couduct-active-box2",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_vm._m(7), _vm._v(" "), _vm._m(8)]) : _vm._e()]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "more-box"
  }, [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "main-solid"
  }), _vm._v(" "), _vm._m(11)]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "more-box"
  }, [_vm._m(12), _vm._v(" "), _vm._m(13)]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "more-box"
  }, [_vm._m(14), _vm._v(" "), _vm._m(15)]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "more-box"
  }, [_vm._m(16), _vm._v(" "), _vm._m(17)]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "more-box"
  }, [_vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "main-solid"
  }), _vm._v(" "), _vm._m(20)]) : _vm._e(), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('TabBar', {
    attrs: {
      "show-tab-bar": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-header-face"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pic-index-face.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-search"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon-index-search.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "index-search-name"
  }, [_vm._v("搜索")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-header-right"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon-index-more.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-active"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "solid solid1"
  }), _vm._v(" "), _c('span', {
    staticClass: "more-title"
  }, [_vm._v("赛事活动")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-items"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pic-homepage-event.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("我的赛事")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-items"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pic-homepage-event2.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("赛事日历")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-items"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pic-homepage-event3.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("成绩查询")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box2-left"
  }, [_c('div', {
    staticClass: "active-couduct-box active-couduct2"
  }, [_vm._v("进行中")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "2.86rem",
      "height": "1.41rem"
    },
    attrs: {
      "src": require("../../assets/images/pic-active-pic2.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box2-right"
  }, [_c('div', {
    staticClass: "active-title"
  }, [_vm._v("2019-2020年武汉站")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('div', [_c('div', {
    staticClass: "time"
  }, [_vm._v("2020-12-01")]), _vm._v(" "), _c('div', {
    staticClass: "address"
  }, [_vm._v("中国·南京")])]), _vm._v(" "), _c('div', {
    staticClass: "to-active-btn"
  }, [_vm._v("进入")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-active"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "solid solid2"
  }), _vm._v(" "), _c('span', {
    staticClass: "more-title"
  }, [_vm._v("培训及会议报名")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "more-right"
  }, [_vm._v("更多")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/images/arrow.png"),
      "alt": "",
      "srcset": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "more-items"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pic-homepage-Meetings-and-training1.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("首次注册")])]), _vm._v(" "), _c('div', {
    staticClass: "more-items"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pic-homepage-Meetings-and-training2.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("报名申请")])]), _vm._v(" "), _c('div', {
    staticClass: "more-items"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pic-homepage-Meetings-and-training3.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("咨询查询")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "train-box flex-between",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_c('div', {
    staticClass: "train-items"
  }, [_c('div', {
    staticClass: "train-items-top items-top1"
  }, [_c('div', [_c('div', {
    staticClass: "train-items-top-city"
  }, [_vm._v("北京")]), _vm._v(" "), _c('div', {
    staticClass: "train-items-top-time"
  }, [_vm._v("12月31日")])]), _vm._v(" "), _c('div', {
    staticClass: "train-sing-up-btn"
  }, [_vm._v("报名")])]), _vm._v(" "), _c('div', {
    staticClass: "train-items-title"
  }, [_vm._v("2020年（北京站）七彩星级B级培训班")]), _vm._v(" "), _c('div', {
    staticClass: "flex-between"
  }, [_c('div', {
    staticClass: "train-items-time"
  }, [_vm._v("2020-12-01")]), _vm._v(" "), _c('div', {
    staticClass: "train-items-address"
  }, [_vm._v("中国·南京")])])]), _vm._v(" "), _c('div', {
    staticClass: "train-items"
  }, [_c('div', {
    staticClass: "train-items-top items-top2"
  }, [_c('div', [_c('div', {
    staticClass: "train-items-top-city"
  }, [_vm._v("北京")]), _vm._v(" "), _c('div', {
    staticClass: "train-items-top-time"
  }, [_vm._v("12月31日")])]), _vm._v(" "), _c('div', {
    staticClass: "train-sing-up-btn"
  }, [_vm._v("报名")])]), _vm._v(" "), _c('div', {
    staticClass: "train-items-title"
  }, [_vm._v("2020年（北京站）七彩星级B级培训班")]), _vm._v(" "), _c('div', {
    staticClass: "flex-between"
  }, [_c('div', {
    staticClass: "train-items-time"
  }, [_vm._v("2020-12-01")]), _vm._v(" "), _c('div', {
    staticClass: "train-items-address"
  }, [_vm._v("中国·南京")])])]), _vm._v(" "), _c('div', {
    staticClass: "train-items"
  }, [_c('div', {
    staticClass: "train-items-top items-top2"
  }, [_c('div', [_c('div', {
    staticClass: "train-items-top-city"
  }, [_vm._v("北京")]), _vm._v(" "), _c('div', {
    staticClass: "train-items-top-time"
  }, [_vm._v("12月31日")])]), _vm._v(" "), _c('div', {
    staticClass: "train-sing-up-btn"
  }, [_vm._v("报名")])]), _vm._v(" "), _c('div', {
    staticClass: "train-items-title"
  }, [_vm._v("2020年（北京站）七彩星级B级培训班")]), _vm._v(" "), _c('div', {
    staticClass: "flex-between"
  }, [_c('div', {
    staticClass: "train-items-time"
  }, [_vm._v("2020-12-01")]), _vm._v(" "), _c('div', {
    staticClass: "train-items-address"
  }, [_vm._v("中国·南京")])])]), _vm._v(" "), _c('div', {
    staticClass: "train-items"
  }, [_c('div', {
    staticClass: "train-items-top items-top2"
  }, [_c('div', [_c('div', {
    staticClass: "train-items-top-city"
  }, [_vm._v("北京")]), _vm._v(" "), _c('div', {
    staticClass: "train-items-top-time"
  }, [_vm._v("12月31日")])]), _vm._v(" "), _c('div', {
    staticClass: "train-sing-up-btn"
  }, [_vm._v("报名")])]), _vm._v(" "), _c('div', {
    staticClass: "train-items-title"
  }, [_vm._v("2020年（北京站）七彩星级B级培训班")]), _vm._v(" "), _c('div', {
    staticClass: "flex-between"
  }, [_c('div', {
    staticClass: "train-items-time"
  }, [_vm._v("2020-12-01")]), _vm._v(" "), _c('div', {
    staticClass: "train-items-address"
  }, [_vm._v("中国·南京")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-active"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "solid solid3"
  }), _vm._v(" "), _c('span', {
    staticClass: "more-title"
  }, [_vm._v("星级俱乐部")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "more-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "more-items"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pic-homepage-club1.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("俱课堂")])]), _vm._v(" "), _c('div', {
    staticClass: "more-items"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pic-homepage-club2.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("我的俱乐部")])]), _vm._v(" "), _c('div', {
    staticClass: "more-items"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pic-homepage-club3.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("四好运动员")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-active"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "solid solid4"
  }), _vm._v(" "), _c('span', {
    staticClass: "more-title"
  }, [_vm._v("境外交流")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "more-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around"
    }
  }, [_c('div', {
    staticClass: "more-items"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pic-homepage-club1.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("外事新闻")])]), _vm._v(" "), _c('div', {
    staticClass: "more-items"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pic-homepage-club2.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("境外活动")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-active"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "solid solid5"
  }), _vm._v(" "), _c('span', {
    staticClass: "more-title"
  }, [_vm._v("积分商城")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "more-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "info-itmes2-box"
  }, [_c('img', {
    staticStyle: {
      "width": "34.5px",
      "height": "30.5px"
    },
    attrs: {
      "src": require("../../assets/images/pic-homepage-Integral-mall1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info-item-title"
  }, [_vm._v("课程")])]), _vm._v(" "), _c('div', {
    staticClass: "info-itmes2-box"
  }, [_c('img', {
    staticStyle: {
      "width": "38px",
      "height": "30.5px"
    },
    attrs: {
      "src": require("../../assets/images/pic-homepage-Integral-mall2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info-item-title"
  }, [_vm._v("课程")])]), _vm._v(" "), _c('div', {
    staticClass: "info-itmes2-box"
  }, [_c('img', {
    staticStyle: {
      "width": "29px",
      "height": "32.5px"
    },
    attrs: {
      "src": require("../../assets/images/pic-homepage-Integral-mall3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info-item-title"
  }, [_vm._v("课程")])]), _vm._v(" "), _c('div', {
    staticClass: "info-itmes2-box"
  }, [_c('img', {
    staticStyle: {
      "width": "27.5px",
      "height": "27.5px"
    },
    attrs: {
      "src": require("../../assets/images/pic-homepage-Integral-mall4.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info-item-title"
  }, [_vm._v("课程")])]), _vm._v(" "), _c('div', {
    staticClass: "info-itmes2-box"
  }, [_c('img', {
    staticStyle: {
      "width": "40.5px",
      "height": "26.5px"
    },
    attrs: {
      "src": require("../../assets/images/pic-homepage-Integral-mall5.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info-item-title"
  }, [_vm._v("课程")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-active"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "solid solid6"
  }), _vm._v(" "), _c('span', {
    staticClass: "more-title"
  }, [_vm._v("新闻中心")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "more-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news"
  }, [_c('div', {
    staticClass: "news-title"
  }, [_vm._v("2017-2018学年南京市阳光体育学校绩效考核的通知")]), _vm._v(" "), _c('div', {
    staticClass: "news-banner"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/pic-active-pic2.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-between",
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_c('div', {
    staticClass: "news-latform"
  }, [_vm._v("CCTV ")]), _vm._v(" "), _c('div', {
    staticClass: "news-read"
  }, [_vm._v("221阅读 ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news"
  }, [_c('div', {
    staticClass: "news-title"
  }, [_vm._v("2017-2018学年南京市阳光体育学校绩效考核的通知")]), _vm._v(" "), _c('div', {
    staticClass: "flex-between",
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_c('div', {
    staticClass: "news-latform"
  }, [_vm._v("CCTV ")]), _vm._v(" "), _c('div', {
    staticClass: "news-read"
  }, [_vm._v("221阅读 ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-box"
  }, [_c('div', {
    staticClass: "more-active"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "solid solid7"
  }), _vm._v(" "), _c('span', {
    staticClass: "more-title"
  }, [_vm._v("合作伙伴")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "partner-box"
  }, [_c('div', {
    staticClass: "partner-items"
  }, [_c('img', {
    staticStyle: {
      "width": "92.5px",
      "height": "39px"
    },
    attrs: {
      "src": require("../../assets/images/pic-homepage-cooperation1.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "partner-items"
  }, [_c('img', {
    staticStyle: {
      "width": "110px",
      "height": "30px"
    },
    attrs: {
      "src": require("../../assets/images/pic-homepage-cooperation2.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "partner-items"
  }, [_c('img', {
    staticStyle: {
      "width": "108px",
      "height": "39px"
    },
    attrs: {
      "src": require("../../assets/images/pic-homepage-cooperation3.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "partner-items"
  }, [_c('img', {
    staticStyle: {
      "width": "99px",
      "height": "39px"
    },
    attrs: {
      "src": require("../../assets/images/pic-homepage-cooperation4.png"),
      "alt": ""
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3647b65c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/Index.vue
// module id = 1448
// module chunks = 0